import { Crown } from "lucide-react";
import { MARQUEE_ITEMS } from "../data/content";

export const Marquee = () => {
  const row = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative border-y border-gold/20 bg-coal/60 py-4 overflow-hidden"
    >
      <div className="flex w-max animate-marquee items-center gap-8 hover:[animation-play-state:paused]">
        {row.map((item, i) => (
          <span
            key={i}
            className="flex items-center gap-8 whitespace-nowrap font-display text-xs sm:text-sm font-semibold uppercase tracking-[0.3em] text-zinc-400"
          >
            {item}
            <Crown className="h-3.5 w-3.5 text-gold/70" />
          </span>
        ))}
      </div>
    </div>
  );
};
